import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getCustomDeviationSetStreamId } from '../helpers';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
import { PapiDeviation } from '@wix/da-papi-types';

export type WithCustomSetDeviationsProps = {
  deviations: PapiDeviation[];
};

const mapStateToProps = state => {
  const streamId = getCustomDeviationSetStreamId();
  return {
    deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
  };
};

export const useCustomSetDeviations = (): WithCustomSetDeviationsProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
});

export default connectMediaStore(mapStateToProps);
